import { default as Company } from '.'
import { PageLayout } from '../../../common/app'
import { RouteObject } from 'react-router-dom'

const basePath = '/settings/company'

/**
 * Venue settings routes. These pages are reached from the topbar app menu
 * flyout and therefore use the centered page style with a breadcrumb at the top.
 */
export const companyRoutes: RouteObject[] = [
  {
    path: `${basePath}/settings`,
    element: (
      <PageLayout title="Settings" htmlTitleOnly alignMainContent="center">
        <Company.Preferences.Component />
      </PageLayout>
    ),
    loader: Company.Preferences.Loader,
  },
  {
    path: `${basePath}/revenue-groups`,
    element: (
      <PageLayout
        title="Revenue Groups"
        htmlTitleOnly
        alignMainContent="center"
      >
        <Company.RevenueGroups.Component />
      </PageLayout>
    ),
    loader: Company.RevenueGroups.Loader,
  },
  {
    path: `${basePath}/connections`,
    element: (
      <PageLayout
        title="App Connections"
        htmlTitleOnly
        alignMainContent="center"
      >
        <Company.Connections.Component />
      </PageLayout>
    ),
    loader: Company.Connections.Loader,
  },
  {
    path: `${basePath}/connections/square`,
    element: (
      <PageLayout
        title="Connect Square"
        htmlTitleOnly
        alignMainContent="center"
      >
        <Company.Connections.Square.Component />
      </PageLayout>
    ),
    loader: Company.Connections.Square.Loader,
  },
  {
    path: `${basePath}/connections/xero`,
    element: (
      <PageLayout title="Connect Xero" htmlTitleOnly alignMainContent="center">
        <Company.Connections.Xero.Component />
      </PageLayout>
    ),
    loader: Company.Connections.Xero.Loader,
  },
]
